import { showMsg } from '@/utils/snackbar'

export default {
    mounted(el) {

        let timeout = null

        el.addEventListener('input', (e) => {

            const value = e.target.value

            const sanitized =
                value.replace(/[^a-zA-Z0-9@._-]/g, '')

            // اگر کاراکتر غیرمجاز داشت
            if (value !== sanitized) {

                // جلوگیری از اسپم snackbar
                if (!timeout) {

                    showMsg(
                        'فقط کاراکترهای مجاز ایمیل قابل استفاده هستند',
                        'red'
                    )

                    timeout = setTimeout(() => {
                        timeout = null
                    }, 1500)
                }

                e.target.value = sanitized

                e.target.dispatchEvent(
                    new Event('input', { bubbles: true })
                )
            }

        })
    }
}
